import Cookies from "js-cookie";

class ToolsUtils {

    static getSystemSync() {
        return {
            windowWidth: window.screen.width
        }
    }
    /**
    * uniapp同名方法  保存到本地
    * @param {
     * } param 
     */
    static getStorage(param) {
        let localdata = localStorage.getItem(param.key);
        if (typeof param.success == 'static') {
            param.success({ data: localdata });
        }
    }

    static setStorage(param) {
        if (typeof param.data != 'string') {
            localStorage.setItem(param.key, JSON.stringify(param.data));
        } else {
            localStorage.setItem(param.key, param.data);
        }

        if (typeof param.success == 'static') {
            param.success();
        }
    }

    static setStorageSync(key, data) {

        let typeStr = Object.prototype.toString.call(data);
        let type = typeStr.replaceAll(/[\[|\]]/mg, "").split(" ");


        let obj = {
            data: data,
            type: type[1].toLowerCase()
        }

        localStorage.setItem(key, JSON.stringify(obj));

    }

    static getStorageSync(key) {
        let temp = null;
        if (localStorage.getItem(key)) {
            temp = JSON.parse(localStorage.getItem(key));
            return temp.data
        }

        return temp;

    }

    static getSystemInfoSync() {
        return {
            screenHeight: document.documentElement.clientHeight,
            screenWidth: document.documentElement.clientWidth,
            windowHeight: document.documentElement.clientHeight,
            windowWidth: document.documentElement.clientWidth,
            statusBarHeight: 0,
        }
    }

    static removeStorage(param) {
        localStorage.removeItem(param.key);
        if (typeof param.success == 'static') {
            param.success();
        }
    }

    static removeStorageSync(key) {
        localStorage.removeItem(key);
    }

    static removeAllStorage() {
        localStorage.clear();
    }


    /**
     * 
     * @param {*} num  待转换的px
     * @param {*} remNum rem的比例   默认37.5
     * @param {*} unitPrecision 保留的精度  默认3位
     * @returns 
     */
    static pxToRem(num, remNum = 37.5, unitPrecision = 3) {

        //固定的remNum在375px下有页面长度计算问题
        //这里获取手机的宽度计算
        let { screenWidth } = this.getSystemInfoSync();
        remNum = screenWidth / 10;

        let uniNum = 1;
        for (let i = 0; i < unitPrecision; i++) {
            uniNum *= 10;
        }
        let temp = Math.floor(num / remNum * uniNum) / uniNum;
        return temp;
    }

    static isObjEmpty(obj) {
        if ( obj == "" || obj == null || obj == undefined || JSON.stringify(obj) == "{}") {
            return true;
        } else {
            return false;
        }
    }

    static checkPhone(phone) {
        if (/^1[23456789]\d{9}$/.test(phone)) {
            return true;
        } else {
            return false;
        }
    }

    static isStrEmpty(str) {
        if (str == "" || str == null || str == undefined || str == "null") {
            return true;
        } else {
            return false;
        }
    }

    static ToastCallBack(obj = { message: "请输入message", icon: "none", duration: 1500 }, fn) {
        Toast(obj);
        let t = setTimeout(() => {
            if (typeof fn == "static") {
                fn();
            }
            clearTimeout(t);
        }, obj.duration ? obj.duration : 1500);
    }

    static getSystemInfoSync() {
        let windowHeight = document.documentElement.clientHeight;
        return {
            windowHeight
        }
    }



    static getUrlParams(paramName) {
        let params = new URLSearchParams(window.location.search);
        return params.get(paramName);
    }


    static setCookiesSync(key, data, expires) {

        let typeStr = Object.prototype.toString.call(data);
        let type = typeStr.replaceAll(/[\[|\]]/mg, "").split(" ");


        let obj = {
            data: data,
            type: type[1].toLowerCase()
        }

        Cookies.set(key, JSON.stringify(obj), { expires: expires });

    }

    static getCookiesSync(key) {
        let temp = null;
        if (Cookies.get(key)) {

            try{
                temp = JSON.parse(Cookies.get(key));
            }catch(e){
                console.log(e);
                return temp;
            }

            return temp.data
        }

        return temp;
    }

    static removeCookiesSync(key){
        Cookies.remove(key);
    }

}

export default ToolsUtils;
